// extracted by mini-css-extract-plugin
export default {"h2":"style__h2___1Tmp_","wrapper":"style__wrapper___wzke9","link":"style__link___2QwgW"};